<template>
  <div>
    <b-card no-body class="mb-2">
      <b-card-header
        header-tag="header"
        role="tab"
        v-b-toggle="'accordion-' + currentIndex"
        header-class="bg-silver"
      >
        <span class="when-open">
          <h6 class="m-0">
            <a class="text-dark" href="javascript: void(0);">{{
              'Etape ' + currentIndex + ' : ' + currentEtape.libelle
            }}</a>
            <span class="accicon">
              <span class="mr-4">
                Statut :
                <i
                  :class="[
                    {
                      'text-warning': currentEtape.statut === 0,
                      'text-success':
                        currentEtape.statut === 1 ||
                        currentEtape.statut === 3 ||
                        currentEtape.statut === 4,
                      'text-danger': currentEtape.statut === 2,
                    }, of.MDI_CHECKBOX_CIRCLE, 'mr-1'
                  ]"
                ></i>
                {{ getStatutEtape(currentEtape.statut) }}
              </span>
              <i :class="of.ICON_ANGLE_UP"></i>
            </span>
          </h6>
        </span>
        <span class="when-closed">
          <h6 class="m-0">
            <a class="text-dark" href="javascript: void(0);">{{
              'Etape ' + currentIndex + ' : ' + currentEtape.libelle
            }}</a>
            <span class="accicon">
              <span class="mr-4">
                Statut :
                <i
                  :class="[
                    {
                      'text-warning': currentEtape.statut === 0,
                      'text-success':
                        currentEtape.statut === 1 ||
                        currentEtape.statut === 3 ||
                        currentEtape.statut === 4,
                      'text-danger': currentEtape.statut === 2,
                    }, of.MDI_CHECKBOX_CIRCLE, 'mr-1'
                  ]"
                ></i>
                {{ getStatutEtape(currentEtape.statut) }}
              </span>
              <i :class="of.ICON_ANGLE_DOWN"></i>
            </span>
          </h6>
        </span>
      </b-card-header>
      <b-collapse
        style="background-color: #f3f3f3"
        :id="'accordion-' + currentIndex"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <div class="p-2">
          <div class="row p-2">
            <div class="col-12 text-lg-right">
              <b-button
                variant="success"
                class="btn-icon mr-4"
                v-if="currentEtape.statut === 0"
                @click="$emit('onDemarrer', currentEtape, currentIndex)"
              >
                <span class="btn-icon-label">
                  <i :class="of.ICON_PLAY"></i>
                </span>
                Démarrer
              </b-button>

              <b-button
                variant="success"
                class="btn-icon mr-4"
                v-if="currentEtape.statut === 1 || currentEtape.statut === 4"
                @click="$emit('onCloturer', currentEtape, currentIndex)"
              >
                <span class="btn-icon-label">
                  <i :class="of.ICON_THUMBS_UP"></i>
                </span>
                Terminer
              </b-button>

              <b-button
                variant="danger"
                class="btn-icon mr-4"
                v-if="
                  currentEtape.statut !== 3 &&
                  currentEtape.statut !== 0 &&
                  currentEtape.statut !== 2
                "
                @click="$emit('onPause', currentEtape)"
              >
                <span class="btn-icon-label">
                  <i :class="of.ICON_STOP"></i>
                </span>
                Pause
              </b-button>

              <b-button
                variant="warning"
                class="btn-icon"
                v-if="currentEtape.statut !== 0"
                @click="$emit('onReinitialiser', currentEtape)"
              >
                <span class="btn-icon-label">
                  <i :class="of.ICON_HOURGLASS"></i>
                </span>
                Réinitialiser
              </b-button>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import URL_E from '@/http/gpao/of-etape';
import { of } from '@/icons/gpao/suivi-of';

export default {
  data() {
    return {
      of,

      //currentEtape: null,
    };
  },

  methods: {
    reinitialiser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.REINITIALISER + '/' + this.currentEtape.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    /*
    demarrer() {
      this.$refs.modalLancement.showModal();

      /*this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.DEMARRER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    }, */
    pause() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.PAUSE + '/' + this.currentEtape.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    terminer() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.CLOTURER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    init() {
      /*window.axios
        .get(URL.ETAPE + '/' + this.etape.id, { params: { suivi_of: true } })
        .then((resp) => {
          this.currentEtape = resp.data.etape;
        })
        .catch();*/
    },
    mounted() {
      console.log('sdsd' + this.currentIndex);
      this.init();
    },
  },
  props: ['currentEtape', 'currentIndex'],
};
</script>

<style lang="scss" scoped>
.list-group-item.active,
.list-group-item.active:hover {
  border-color: #f4c334 !important;
  background-color: #ffffff;
  color: black;
}

::v-deep .pagination .page-link {
  /*background: #f4c334 ;*/
  color: #363636;
}
::v-deep .pagination .active button {
  background: #f4c334;
  border: #f4c334 1px solid;
}

/***** */

.card-header .accicon {
  float: right;
}
.card-header {
  cursor: pointer;
  border-bottom: 5px;
}
.card {
  border: 1px solid #ddd;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
